var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoginLayout',[_c('b-card',{staticClass:"text-center"},[_c('h1',[_vm._v("Airline Check-in")]),_c('p',[_vm._v(_vm._s(_vm.error || "We are processing your check-in request..."))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }